/* AgroMel theme JS: carrito AJAX, variantes, galería, menú móvil */

/* Estado del boton de pago. Vive en el nivel raiz del archivo, fuera de los
   dos IIFE que lo usan: el selector de comuna y el de dia viven en alcances
   distintos, asi que declararlo dentro de uno lo dejaba invisible para el otro.
   Cada selector puede bloquear por su cuenta, y quien resuelva el estado tiene
   que mirar los dos a la vez o el ultimo en correr desbloquea lo del otro. */
function agromelBloqueoPago() {
  var boton = document.querySelector('[data-checkout-btn]');
  if (!boton) return;

  var bloqueado = false;

  var comunaCaja = document.querySelector('[data-selector-comuna][data-bloqueo-activo]');
  if (comunaCaja) {
    var comunaSel = comunaCaja.querySelector('[data-comuna-select]');
    var opcion = comunaSel && comunaSel.options[comunaSel.selectedIndex];
    if (!comunaSel || !comunaSel.value || (opcion && opcion.dataset.acordar)) bloqueado = true;
  }

  var diaCaja = document.querySelector('[data-selector-dia][data-bloqueo-activo]');
  if (diaCaja) {
    var diaSel = diaCaja.querySelector('[data-dia-select]');
    if (!diaSel || !diaSel.value) bloqueado = true;
  }

  boton.disabled = bloqueado;
}

(function () {
  'use strict';

  /* ---------- Carrito AJAX ---------- */

  function actualizarContadores(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function refrescarCarrito() {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        actualizarContadores(cart.item_count);
        return cart;
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    var textoOriginal = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Agregando…'; }

    fetch(form.action + '.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'No se pudo agregar'); });
        return r.json();
      })
      .then(function () { return refrescarCarrito(); })
      .then(function () {
        if (btn) { btn.textContent = '✓ Agregado'; setTimeout(function () { btn.textContent = textoOriginal; btn.disabled = false; }, 1500); }
      })
      .catch(function (err) {
        if (btn) { btn.textContent = textoOriginal; btn.disabled = false; }
        var aviso = form.querySelector('[data-cart-error]');
        if (aviso) { aviso.textContent = err.message; aviso.hidden = false; setTimeout(function () { aviso.hidden = true; }, 4000); }
      });
  });

  /* ---------- Steppers (+/−) ---------- */

  document.addEventListener('click', function (e) {
    var boton = e.target.closest('[data-stepper]');
    if (!boton) return;
    var stepper = boton.closest('.stepper');
    var input = stepper && stepper.querySelector('input[type="number"]');
    if (!input) return;
    var valor = parseInt(input.value, 10) || 1;
    var min = parseInt(input.min, 10) || 0;
    if (boton.dataset.stepper === 'mas') valor += 1;
    else valor = Math.max(min, valor - 1);
    input.value = valor;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* En la página de carrito, cambiar cantidad envía el formulario */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('form[data-cart-form] input[type="number"]');
    if (input) input.form.submit();
  });

  /* ---------- Selector de variantes (ficha de producto) ---------- */

  var ficha = document.querySelector('[data-product-json]');
  if (ficha) {
    var producto = JSON.parse(ficha.textContent);
    var raiz = document.querySelector('[data-product-root]');

    function formatearPrecio(centavos) {
      var formato = raiz.dataset.moneyFormat || '${{amount_no_decimals}}';
      var monto = Math.round(centavos / 100).toLocaleString('es-CL');
      return formato
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, monto)
        .replace(/\{\{\s*amount\s*\}\}/, monto);
    }

    function opcionesSeleccionadas() {
      var valores = [];
      raiz.querySelectorAll('[data-option-index]').forEach(function (grupo) {
        var marcado = grupo.querySelector('input:checked');
        valores[parseInt(grupo.dataset.optionIndex, 10)] = marcado ? marcado.value : null;
      });
      return valores;
    }

    function variantePara(valores) {
      // Sin selectores de opciones (producto de variante unica) no hay nada que
      // emparejar: la unica variante es siempre la correcta.
      if (!valores.length) return producto.variants[0];
      return producto.variants.find(function (v) {
        return v.options.every(function (op, i) { return op === valores[i]; });
      });
    }

    function actualizar() {
      var variante = variantePara(opcionesSeleccionadas());
      var inputId = raiz.querySelector('input[name="id"]');
      var precioEl = raiz.querySelector('[data-price]');
      var compareEl = raiz.querySelector('[data-compare-price]');
      var ahorroEl = raiz.querySelector('[data-savings]');
      var btn = raiz.querySelector('[data-add-button]');

      if (!variante) {
        if (btn) { btn.disabled = true; btn.textContent = 'No disponible'; }
        return;
      }
      inputId.value = variante.id;
      if (precioEl) {
        // Mismo orden que el snippet unidad-venta: primero la medida nativa de
        // Shopify (kg, unidad...), y solo si no hay, el titulo de la variante.
        var medida = variante.unit_price_measurement || {};
        var referencia = (medida.reference_unit || '').toLowerCase();
        var traduccion = { item: 'unidad', l: 'litro' };
        var unidad;
        if (referencia) {
          unidad = traduccion[referencia] || referencia;
        } else if (raiz.dataset.unidadFija) {
          unidad = raiz.dataset.unidadFija;
        } else if (variante.title && variante.title !== 'Default Title') {
          // Con dos opciones el titulo es "Un kilo / grande": como unidad solo
          // sirve la primera, que es el formato.
          unidad = parseInt(raiz.dataset.opciones, 10) > 1
            ? variante.options[0]
            : variante.title;
        } else {
          unidad = raiz.dataset.unidad || '';
        }
        unidad = (unidad || '').toLowerCase();
        precioEl.innerHTML = formatearPrecio(variante.price) + (unidad ? ' <small>/ ' + unidad + '</small>' : '');
      }

      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        var ahorro = variante.compare_at_price - variante.price;
        var pct = Math.round(ahorro * 100 / variante.compare_at_price);
        if (compareEl) { compareEl.innerHTML = 'Antes: <s>' + formatearPrecio(variante.compare_at_price) + '</s>'; compareEl.hidden = false; }
        if (ahorroEl) { ahorroEl.textContent = 'Ahorras ' + formatearPrecio(ahorro); ahorroEl.hidden = false; }
      } else {
        if (compareEl) compareEl.hidden = true;
        if (ahorroEl) ahorroEl.hidden = true;
      }

      if (btn) {
        if (variante.available) { btn.disabled = false; btn.textContent = 'Agregar al carrito'; }
        else { btn.disabled = true; btn.textContent = 'Agotado'; }
      }
    }

    raiz.addEventListener('change', function (e) {
      if (e.target.matches('[data-option-index] input')) actualizar();
    });
    actualizar();
  }

  /* ---------- Galería ---------- */

  document.addEventListener('click', function (e) {
    var mini = e.target.closest('[data-thumb]');
    if (!mini) return;
    var principal = document.querySelector('[data-main-image]');
    var img = mini.querySelector('img');
    if (principal && img) {
      principal.src = img.dataset.full || img.src;
      principal.alt = img.alt;
    }
    document.querySelectorAll('[data-thumb]').forEach(function (m) { m.classList.remove('activa'); });
    mini.classList.add('activa');
  });

  /* ---------- Árbol de categorías (aside) ---------- */

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-arbol-toggle]');
    if (!t) return;
    var fam = t.closest('.arbol__familia');
    var abierta = fam.classList.toggle('abierta');
    t.setAttribute('aria-expanded', abierta ? 'true' : 'false');
  });

  /* ---------- Desplegables del submenú ---------- */

  function cerrarDropdowns(excepto) {
    document.querySelectorAll('[data-dropdown].abierto').forEach(function (d) {
      if (d === excepto) return;
      d.classList.remove('abierto');
      var b = d.querySelector('[data-dropdown-toggle]');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var boton = e.target.closest('[data-dropdown-toggle]');
    var item = boton ? boton.closest('[data-dropdown]') : null;
    cerrarDropdowns(item);
    if (!boton) return;
    e.preventDefault();
    var abierto = item.classList.toggle('abierto');
    boton.setAttribute('aria-expanded', abierto ? 'true' : 'false');
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') cerrarDropdowns(null);
  });

  /* ---------- Menú offcanvas ---------- */

  var offcanvas = document.querySelector('[data-offcanvas]');

  var offcanvasTitulo = offcanvas ? offcanvas.querySelector('.offcanvas__titulo') : null;
  var tituloOriginal = offcanvasTitulo ? offcanvasTitulo.textContent : '';

  function abrirOffcanvas(soloSubmenu) {
    if (!offcanvas) return;
    offcanvas.classList.toggle('offcanvas--solo-submenu', Boolean(soloSubmenu));
    if (offcanvasTitulo) {
      var boton = document.querySelector('[data-subnav-toggle]');
      offcanvasTitulo.textContent = soloSubmenu && boton
        ? boton.textContent.trim()
        : tituloOriginal;
    }
    offcanvas.classList.add('abierto');
    document.body.classList.add('sin-scroll');
    var cerrar = offcanvas.querySelector('[data-offcanvas-cerrar]');
    if (cerrar) cerrar.focus();
  }

  function cerrarOffcanvas() {
    if (!offcanvas) return;
    offcanvas.classList.remove('abierto');
    document.body.classList.remove('sin-scroll');
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-toggle]')) { abrirOffcanvas(false); return; }
    if (e.target.closest('[data-subnav-toggle]')) { abrirOffcanvas(true); return; }
    if (e.target.closest('[data-offcanvas-cerrar]')) { cerrarOffcanvas(); return; }

    // Acordeones del submenú dentro del panel
    var toggle = e.target.closest('[data-acordeon-toggle]');
    if (toggle) {
      var grupo = toggle.closest('[data-acordeon]');
      var abierto = grupo.classList.toggle('abierto');
      toggle.setAttribute('aria-expanded', abierto ? 'true' : 'false');
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') cerrarOffcanvas();
  });

  /* ---------- Submenú: una fila o botón ----------
     Si los enlaces no caben en una sola fila, la barra se reemplaza por un
     botón que abre el panel lateral. Se recalcula al redimensionar, así que si
     el cliente quita categorías y vuelven a caber, la barra reaparece sola.
     Bajo 900px el CSS esconde toda la barra y manda la hamburguesa del header:
     por eso aquí se sale temprano cuando la fila no es visible. */
  (function () {
    var subnav = document.querySelector('[data-subnav]');
    if (!subnav) return;

    var fila = subnav.querySelector('.subnav__fila');
    var boton = subnav.querySelector('[data-subnav-toggle]');
    if (!fila || !boton) return;

    var enlaces = Array.prototype.slice.call(fila.children).filter(function (el) {
      return el !== boton;
    });
    if (!enlaces.length) return;

    var anchoNecesario = 0;
    var ajustando = false;

    function medir() {
      var estilos = getComputedStyle(fila);
      var gap = parseFloat(estilos.columnGap) || 0;
      var total = 0;
      enlaces.forEach(function (el) { total += el.getBoundingClientRect().width; });
      total += gap * (enlaces.length - 1);
      if (total > 0) anchoNecesario = total;
    }

    function ajustar() {
      // offsetParent nulo = la barra está oculta (móvil): no hay nada que decidir.
      if (ajustando || !fila.offsetParent) return;
      ajustando = true;

      // Solo se puede medir con los enlaces a la vista.
      if (!subnav.classList.contains('compacta')) medir();

      var estilos = getComputedStyle(fila);
      var disponible = fila.clientWidth
        - (parseFloat(estilos.paddingLeft) || 0)
        - (parseFloat(estilos.paddingRight) || 0);

      if (anchoNecesario) {
        subnav.classList.toggle('compacta', anchoNecesario > disponible + 1);
      }
      ajustando = false;
    }

    ajustar();
    if (window.ResizeObserver) {
      new ResizeObserver(ajustar).observe(fila);
    } else {
      window.addEventListener('resize', ajustar);
    }
    // Las tipografías web cambian el ancho de los enlaces al terminar de cargar.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(ajustar);
  })();

  /* ---------- Carrusel del hero ----------
     Los slides se cruzan con opacidad y se manejan solo con los indicadores (y
     deslizando el dedo en móvil). La reproducción automática se pausa con el
     mouse encima, con el foco del teclado dentro y cuando la pestaña pasa a
     segundo plano, para que nadie se pierda un slide que no vio. */
  (function () {
    var hero = document.querySelector('[data-hero]');
    if (!hero) return;

    var slides = hero.querySelectorAll('[data-hero-slide]');
    if (slides.length < 2) return;

    var puntos = hero.querySelectorAll('[data-hero-punto]');
    var intervalo = (parseFloat(hero.dataset.intervalo) || 6) * 1000;
    var autoPedido = hero.dataset.auto === '1';
    var sinMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var actual = 0;
    var reloj = null;

    function ir(indice) {
      actual = (indice + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('activo', i === actual);
      });
      puntos.forEach(function (punto, i) {
        punto.classList.toggle('activo', i === actual);
        punto.setAttribute('aria-selected', i === actual ? 'true' : 'false');
      });
    }

    function arrancar() {
      if (!autoPedido || sinMovimiento || reloj) return;
      reloj = setInterval(function () { ir(actual + 1); }, intervalo);
    }

    function parar() {
      clearInterval(reloj);
      reloj = null;
    }

    hero.addEventListener('click', function (e) {
      var punto = e.target.closest('[data-hero-punto]');
      if (!punto) return;
      parar();
      ir(parseInt(punto.dataset.heroPunto, 10));
      arrancar();
    });

    hero.addEventListener('mouseenter', parar);
    hero.addEventListener('mouseleave', arrancar);
    hero.addEventListener('focusin', parar);
    hero.addEventListener('focusout', function (e) {
      if (!hero.contains(e.relatedTarget)) arrancar();
    });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) parar(); else arrancar();
    });

    /* Deslizar con el dedo: en móvil no hay flechas */
    var inicioX = null;
    hero.addEventListener('touchstart', function (e) {
      inicioX = e.changedTouches[0].clientX;
      parar();
    }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      if (inicioX === null) return;
      var recorrido = e.changedTouches[0].clientX - inicioX;
      if (Math.abs(recorrido) > 45) ir(recorrido < 0 ? actual + 1 : actual - 1);
      inicioX = null;
      arrancar();
    }, { passive: true });

    arrancar();
  })();

  /* ---------- Globo del botón de WhatsApp ----------
     Los mensajes rotan casi sin pausa: uno visible, un respiro corto y entra el
     siguiente. Se detiene apenas el visitante hace clic: si ya fue al chat,
     insistir molesta. */
  (function () {
    var contenedor = document.querySelector('[data-wsp]');
    if (!contenedor) return;

    var globo = contenedor.querySelector('[data-wsp-globo]');
    var datos = contenedor.querySelector('[data-wsp-mensajes]');
    if (!globo || !datos) return;

    var mensajes;
    try {
      mensajes = JSON.parse(datos.textContent);
    } catch (error) {
      return;
    }
    mensajes = (mensajes || []).map(function (t) { return String(t).trim(); }).filter(Boolean);
    if (!mensajes.length) return;

    var espera = (parseFloat(contenedor.dataset.espera) || 4) * 1000;
    var duracion = (parseFloat(contenedor.dataset.duracion) || 6) * 1000;
    var pausa = (parseFloat(contenedor.dataset.pausa) || 2) * 1000;
    var indice = 0;
    var detenido = false;
    var temporizadores = [];

    function limpiar() {
      temporizadores.forEach(clearTimeout);
      temporizadores = [];
    }

    function esconder() {
      globo.classList.remove('visible');
      temporizadores.push(setTimeout(function () { globo.hidden = true; }, 320));
    }

    function alVolverAlFrente() {
      document.addEventListener('visibilitychange', function propio() {
        if (document.hidden) return;
        document.removeEventListener('visibilitychange', propio);
        temporizadores.push(setTimeout(mostrar, 1500));
      });
    }

    function mostrar() {
      if (detenido) return;
      // En una pestaña de fondo el globo se perdería: se espera a que vuelva al
      // frente en vez de gastar el turno.
      if (document.hidden) return alVolverAlFrente();
      globo.textContent = mensajes[indice % mensajes.length];
      indice++;
      globo.hidden = false;
      // Un respiro para que la transición arranque desde el estado oculto.
      // Con requestAnimationFrame el navegador lo posterga si la pestaña no
      // está enfocada y el globo aparecía de golpe, sin animar.
      temporizadores.push(setTimeout(function () { globo.classList.add('visible'); }, 30));
      temporizadores.push(setTimeout(esconder, duracion));
      programar();
    }

    function programar() {
      // La pausa corre desde que el globo empieza a irse, no desde que aparece
      temporizadores.push(setTimeout(mostrar, duracion + pausa));
    }

    contenedor.addEventListener('click', function () {
      detenido = true;
      limpiar();
      esconder();
    });

    temporizadores.push(setTimeout(mostrar, espera));
  })();

/* ---------- Selector de comuna del carrito ----------
     Guarda la comuna como atributo del carrito apenas se elige, sin esperar a
     que el cliente presione "Actualizar carrito": es el dato que la función de
     envíos usa después en el checkout. */
  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-comuna-select]');
    if (!select) return;

    var contenedor = select.closest('[data-selector-comuna]');
    var opcion = select.options[select.selectedIndex];
    var aviso = contenedor.querySelector('[data-comuna-aviso]');
    var comuna = select.value;
    /* El select solo lista comunas con despacho, asi que lo unico sin cobertura
       que se puede elegir es la salida "mi comuna no esta en la lista". Se sigue
       leyendo data-acordar y no data-otra porque es el mismo dato que mira
       agromelBloqueoPago: un solo criterio para el aviso y para el boton. */
    var sinCobertura = Boolean(comuna) && Boolean(opcion.dataset.acordar);

    var bloqueoActivo = contenedor.hasAttribute('data-bloqueo-activo');

    if (aviso) {
      if (!comuna) {
        /* Sin comuna el pago queda bloqueado, así que hay que decir por qué. */
        aviso.hidden = !bloqueoActivo;
        aviso.className = 'selector-comuna__aviso selector-comuna__aviso--pendiente';
        aviso.textContent = bloqueoActivo ? 'Elige tu comuna para continuar al pago.' : '';
      } else if (sinCobertura) {
        aviso.hidden = false;
        aviso.className = 'selector-comuna__aviso selector-comuna__aviso--acordar';
        aviso.textContent = 'Coordinamos tu despacho por WhatsApp.';
      } else {
        aviso.hidden = false;
        aviso.className = 'selector-comuna__aviso';
        /* El texto lo arma Liquid con el umbral del ajuste del carrito, para no
           repetir el monto aca y que no se desfase cuando el cliente lo cambie. */
        aviso.textContent = comuna + (contenedor.dataset.avisoDespacho || '.');
      }
    }

    /* No dejamos pagar sin comuna elegida, ni con una comuna que se coordina a
       mano. El botón también llega bloqueado desde Liquid; esto cubre el cambio
       en vivo, sin recargar. */
    if (bloqueoActivo) {
      agromelBloqueoPago();

      var bloqueo = contenedor.querySelector('[data-comuna-bloqueo]');
      if (bloqueo) bloqueo.hidden = !sinCobertura;

      var wa = contenedor.querySelector('[data-comuna-whatsapp]');
      if (wa && sinCobertura) {
        var texto = 'Hola, quiero hacer un pedido y mi comuna no está en la lista.';
        wa.href = wa.dataset.base + '?text=' + encodeURIComponent(texto);
      }
    }

    select.disabled = true;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { Comuna: comuna } })
    })
      .catch(function () {})
      .then(function () { select.disabled = false; });
  });

  refrescarCarrito();
})();

/* ---------- Día de entrega del carrito ----------
   Mismo patrón que la comuna: se guarda como atributo apenas se elige, para que
   sobreviva al refresco del carrito y llegue al pedido. */
(function () {
  var caja = document.querySelector('[data-selector-dia]');
  if (!caja) return;

  var select = caja.querySelector('[data-dia-select]');
  var aviso = caja.querySelector('[data-dia-aviso]');
  if (!select) return;

  select.addEventListener('change', function () {
    var dia = select.value;

    if (aviso) {
      aviso.hidden = false;
      if (dia) {
        aviso.className = 'selector-comuna__aviso';
        aviso.textContent = 'Lo preparamos para el ' + dia.toLowerCase() + '.';
      } else {
        aviso.className = 'selector-comuna__aviso selector-comuna__aviso--pendiente';
        aviso.textContent = caja.hasAttribute('data-bloqueo-activo')
          ? 'Elige el día de entrega para continuar al pago.'
          : '';
      }
    }

    agromelBloqueoPago();

    select.disabled = true;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      /* La clave es el nombre exacto que se ve en el pedido y en el correo. */
      body: JSON.stringify({ attributes: { 'Día de entrega': dia } })
    })
      .catch(function () {})
      .then(function () { select.disabled = false; });
  });
})();

/* ---------- Cupón en el carrito ----------
   Se aplica con /cart/update.js pasando {discount: CODIGO}. Comprobado contra la
   tienda: la respuesta trae discount_codes con un flag `applicable`, así que el
   código malo se detecta sin recargar. Ojo: aplicar un código REEMPLAZA al
   anterior, también cuando el nuevo no sirve; por eso, si falla, se repone el que
   ya estaba en vez de dejar al cliente sin su descuento. */
(function () {
  var caja = document.querySelector('[data-cupon]');
  if (!caja) return;

  var input = caja.querySelector('[data-cupon-input]');
  var boton = caja.querySelector('[data-cupon-btn]');
  var error = caja.querySelector('[data-cupon-error]');
  var quitar = caja.querySelector('[data-cupon-quitar]');

  function enviar(codigo) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: codigo })
    }).then(function (r) { return r.json(); });
  }

  function avisar(texto) {
    if (!error) return;
    error.hidden = !texto;
    error.textContent = texto || '';
  }

  function aplicar() {
    var codigo = (input.value || '').trim();
    if (!codigo) { input.focus(); return; }

    var previo = caja.dataset.codigoActual || '';
    boton.disabled = true;
    avisar('');

    enviar(codigo).then(function (carrito) {
      var codigos = carrito.discount_codes || [];
      var sirve = codigos.some(function (c) {
        return c.applicable && c.code.toLowerCase() === codigo.toLowerCase();
      });

      if (sirve) { window.location.reload(); return; }

      /* Shopify devuelve applicable:false tanto si el codigo no existe como si
         existe pero no cubre los productos del carrito: se nombran los dos casos
         para que el cliente sepa que puede sumar el producto en promocion. */
      var existe = codigos.some(function (c) {
        return c.code.toLowerCase() === codigo.toLowerCase();
      });
      avisar(existe
        ? 'El código ' + codigo + ' no aplica a los productos de tu carrito.'
        : 'El código ' + codigo + ' no es válido o ya venció.');
      boton.disabled = false;
      input.select();
      /* El intento fallido borró el cupón que sí servía: lo reponemos. */
      if (previo) { return enviar(previo); }
    }).catch(function () {
      avisar('No pudimos aplicar el código. Inténtalo de nuevo.');
      boton.disabled = false;
    });
  }

  boton.addEventListener('click', aplicar);

  /* El input está dentro del <form> del carrito: sin esto, Enter guardaría
     el carrito en vez de aplicar el cupón. */
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') { e.preventDefault(); aplicar(); }
  });

  if (quitar) {
    quitar.addEventListener('click', function () {
      quitar.disabled = true;
      enviar('').then(function () { window.location.reload(); })
                .catch(function () { quitar.disabled = false; });
    });
  }
})();

/* ---------- Notas del pedido ----------
   La nota viaja sola con el botón de pago, porque el campo está dentro del
   formulario del carrito. Pero quitar un producto es un enlace que recarga la
   página sin enviar el formulario, y lo escrito se perdería: por eso también se
   guarda al salir del campo. keepalive deja terminar el guardado aunque el clic
   que sacó el foco sea justamente ese enlace. */
(function () {
  var campo = document.querySelector('[data-nota-pedido]');
  if (!campo) return;

  var guardada = campo.value;
  campo.addEventListener('change', function () {
    var valor = campo.value;
    if (valor === guardada) return;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: valor }),
      keepalive: true
    })
      .then(function (r) { if (r.ok) guardada = valor; })
      .catch(function () {});
  });
})();

/* ---------- Filtros de la tienda en móvil ----------
   El botón "Filtros" abre la barra lateral como panel. Se cierra con la X, al
   tocar el fondo o con Escape, y también si la pantalla crece a tamaño de
   escritorio, porque ahí la barra vuelve a ser columna y el scroll bloqueado del
   body quedaría pegado. */
(function () {
  var panel = document.querySelector('[data-filtros-drawer]');
  if (!panel) return;
  var velo = document.querySelector('[data-filtros-velo]');
  var boton = document.querySelector('[data-filtros-abrir]');

  function abrir() {
    panel.classList.add('abierto');
    if (velo) velo.hidden = false;
    document.body.classList.add('sin-scroll');
    if (boton) boton.setAttribute('aria-expanded', 'true');
    var cerrar = panel.querySelector('[data-filtros-cerrar]');
    if (cerrar) cerrar.focus();
  }

  function cerrar() {
    if (!panel.classList.contains('abierto')) return;
    panel.classList.remove('abierto');
    if (velo) velo.hidden = true;
    document.body.classList.remove('sin-scroll');
    if (boton) { boton.setAttribute('aria-expanded', 'false'); boton.focus(); }
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-filtros-abrir]')) { e.preventDefault(); abrir(); }
    else if (e.target.closest('[data-filtros-cerrar]')) { e.preventDefault(); cerrar(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') cerrar();
  });
  var escritorio = window.matchMedia('(min-width: 901px)');
  var alCambiar = function (m) { if (m.matches) cerrar(); };
  if (escritorio.addEventListener) escritorio.addEventListener('change', alCambiar);
  else if (escritorio.addListener) escritorio.addListener(alCambiar);
})();

/* ---------- Buscador en móvil ----------
   La lupa del encabezado muestra u oculta la barra de búsqueda y deja el cursor
   en el campo, así el teclado aparece de inmediato. */
(function () {
  var boton = document.querySelector('[data-buscar-toggle]');
  var fila = document.querySelector('[data-buscador-movil]');
  if (!boton || !fila) return;
  var campo = fila.querySelector('input[type="search"]');

  function mostrar(abierta) {
    fila.hidden = !abierta;
    boton.setAttribute('aria-expanded', abierta ? 'true' : 'false');
    if (abierta && campo) campo.focus();
  }

  boton.addEventListener('click', function () { mostrar(fila.hidden); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !fila.hidden) { mostrar(false); boton.focus(); }
  });
})();
